import React from 'react'
import { Hero } from 'react-bulma-components'
import styled from 'styled-components'
import { Container } from 'react-bulma-components'
import {
    StyledHeading,
    StyledHero,
    StyledContainer,
    StyledContent,
} from '../../utils/commonStyles'
import { StaticImage } from 'gatsby-plugin-image'
import { useTranslation } from 'gatsby-plugin-react-i18next'

const CustomStyledHero = styled(StyledHero)`
    min-height: 200px;
    margin-top: 0rem;
    margin-bottom: 4rem;
`

const CustomStyledContainer = styled(StyledContainer)`
    margin-top: 2rem !important;
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    .content {
        margin-left: 1rem;
        margin-right: 1rem;
    }

    .container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: 100%;
        width: 100%;
    }

    h1 {
        text-align: center;
        margin-top: 1rem;
        color: #faa735;
        width: 75%;
    }

    @media only screen and (max-width: 600px) {
        flex-direction: column;
    }

    @media only screen and (max-width: 768px) {
        h1 {
            width: 100% !important;
        }
    }
`

export default function Body() {
    const { t } = useTranslation()
    return (
        <CustomStyledHero>
            <Hero.Body style={{ position: 'relative' }}>
                <Container>
                    <StyledContent>{t('onas.body.text1')}</StyledContent>
                    <StyledContent>{t('onas.body.text2')}</StyledContent>
                    <StyledContent>{t('onas.body.text3')}</StyledContent>
                </Container>
                <CustomStyledContainer>
                    <Container>
                        <StaticImage
                            src={'../../images/oNas/razvoj.png'}
                            width={150}
                            alt="Razvoj"
                        />
                        <StyledHeading size={5}>
                            {t('onas.body.box1')}
                        </StyledHeading>
                    </Container>
                    <Container>
                        <StaticImage
                            src={'../../images/oNas/dvapanela.png'}
                            width={150}
                            alt="Sončni paneli"
                        />
                        <StyledHeading size={5}>
                            {t('onas.body.box2')}
                        </StyledHeading>
                    </Container>
                    <Container>
                        <StaticImage
                            src={'../../images/oNas/elek_avto.png'}
                            width={150}
                            alt="Električni avto"
                        />
                        <StyledHeading size={5}>
                            {t('onas.body.box3')}
                        </StyledHeading>
                    </Container>
                    <Container>
                        <StaticImage
                            src={'../../images/oNas/mikroelek.png'}
                            width={150}
                            alt="Mikro elektrarna"
                        />
                        <StyledHeading size={5}>
                            {' '}
                            {t('onas.body.box4')}
                        </StyledHeading>
                    </Container>
                    <Container>
                        <StaticImage
                            src={'../../images/oNas/baterija.png'}
                            width={150}
                            alt="Baterijski hranilnik"
                        />
                        <StyledHeading size={5}>
                            {t('onas.body.box5')}
                        </StyledHeading>
                    </Container>
                    <Container>
                        <StaticImage
                            src={'../../images/oNas/skupnost.png'}
                            width={150}
                            alt="Energetske skupnosti"
                        />
                        <StyledHeading size={5}>
                            {t('onas.body.box6')}
                        </StyledHeading>
                    </Container>
                </CustomStyledContainer>
            </Hero.Body>
        </CustomStyledHero>
    )
}
